/**
 * Retake-pending marker: set when the user confirms a retake on Results, read
 * by the /app entry router to start fresh instead of resolving to the previous
 * submission, and cleared once the new attempt's in-progress draft exists.
 *
 * localStorage (not session) so the pending retake survives a browser restart;
 * keyed per signed-in account so one account's retake never reroutes another
 * account on the same machine. All access is best-effort — a storage exception
 * must never break navigation (the retake then degrades to entry-by-latest).
 */

const KEY_PREFIX = 'aita-retake-pending';

function markerKey(oid: string | null): string {
  return `${KEY_PREFIX}:${oid ?? 'unknown'}`;
}

export function setRetakeMarker(oid: string | null): void {
  try {
    localStorage.setItem(markerKey(oid), '1');
  } catch {
    // Storage unavailable — entry routing falls back to the latest submission.
  }
}

export function hasRetakeMarker(oid: string | null): boolean {
  try {
    return localStorage.getItem(markerKey(oid)) !== null;
  } catch {
    return false;
  }
}

export function clearRetakeMarker(oid: string | null): void {
  try {
    localStorage.removeItem(markerKey(oid));
  } catch {
    // Already unreadable — nothing to clear.
  }
}
